import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ModuleFacade } from '../facades/module.facade';

export function moduleCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const moduleFacade = inject(ModuleFacade);
        moduleFacade.clear();

        return true;
    };
}
